import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { Bank } from "src/app/parametrage/core/model/bank";
import { Direction } from "src/app/parametrage/core/model/direction";
import { Departement } from "src/app/parametrage/core/model/departement";
import { BankService } from "src/app/parametrage/core/service/bank.service";
import { DirectionService } from "src/app/parametrage/core/service/direction.service";
import { EmployeeService } from "src/app/parametrage/core/service/employee.service";
import { DepartementService } from "src/app/parametrage/core/service/departement.service";
import { UpdateEmployee } from "src/app/parametrage/core/model/employee/update-employee";

interface Alert {
  type: string;
  message: string;
}

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent {
  alerts: Alert[] = [];

  pressButton: Boolean = false;
  form: FormGroup;

  public file: File;
  public photo: string | ArrayBuffer;
  public photoContentType: String;

  employee: Employee;
  banks: Bank[];
  directions: Direction[];
  departements: Departement[];

  updateEmployee: UpdateEmployee = new UpdateEmployee();

  constructor(
    private _router: Router,
    private _bankService: BankService,
    private _drectionService: DirectionService,
    private _employeeService: EmployeeService,
    private _departementService: DepartementService,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      matricule: [null, Validators.compose([Validators.required])],
      poste: [null, Validators.compose([Validators.required])],
      firstname: [null, Validators.compose([Validators.required])],
      lastname: [null, Validators.compose([Validators.required])],
      initiale: [null, Validators.compose([Validators.required])],
      businessEmail: [null, Validators.compose([Validators.required])],
      businessPhone: [null, Validators.compose([Validators.required])],
      username: [null, Validators.compose([Validators.required])],
      photo: [null, Validators.compose([Validators.nullValidator])],
      direction: [null, Validators.compose([Validators.required])],
      departement: [null, Validators.compose([Validators.required])],
      bank: [null, Validators.compose([Validators.required])],
      codeAgent: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getUserInfo();
    this.getDirections();
    this.getBanks();
  }

  getUserInfo() {
    this._employeeService.getCurrentEmployee().subscribe(
      (data) => {
        this.employee = data;
        this.getDepartementsByDirection(this.employee.departement.direction.id);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getDirections() {
    this._drectionService.getAllDirections().subscribe(
      (data) => {
        this.directions = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  changeDepartements() {
    let directionid = this.form.controls["direction"].value;
    this.getDepartementsByDirection(directionid);
  }

  getDepartementsByDirection(directionid) {
    this._departementService.getDepartementsByDirection(directionid).subscribe(
      (data) => {
        this.departements = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getBanks() {
    this._bankService.getAllBanks().subscribe(
      (data) => {
        this.banks = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  changeListener($event) {
    this.readThis($event.target);
  }

  readThis(inputValue: any): void {
    this.file = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.employee.photo = myReader.result.toString().split(",")[1];
      this.employee.photoContentType = this.file.type;
    };
    myReader.readAsDataURL(this.file);
  }

  changePhoto(): void {
    this.readThis(this.form.value.photo);
  }

  save(): void {
    this.updateEmployee.employeeId = this.employee.id;
    this.updateEmployee.matricule = this.form.value.matricule;
    this.updateEmployee.poste = this.form.value.poste;
    this.updateEmployee.firstname = this.form.value.firstname;
    this.updateEmployee.lastname = this.form.value.lastname;
    this.updateEmployee.mobilePhone = this.form.value.mobilePhone;
    this.updateEmployee.businessEmail = this.form.value.businessEmail;
    this.updateEmployee.businessPhone = this.form.value.businessPhone;
    this.updateEmployee.photo = this.employee.photo;
    this.updateEmployee.photoContentType = this.employee.photoContentType;
    this.updateEmployee.codeAgent = this.form.value.codeAgent;
    this.updateEmployee.initiale = this.form.value.initiale;
    this.updateEmployee.departementId = this.form.value.departement;

    this.alerts = [];

    this._employeeService
      .update(this.updateEmployee)
      .pipe(first())
      .subscribe(
        (data) => {
          this.alerts.push({
            type: "success",
            message: "Les modifications ont été enregistrées",
          });
        },
        (error) => {
          console.log(error);

          this.alerts.push({
            type: "danger",
            message: "Les modifications n'ont pas été enregistrées",
          });
        }
      );
  }

  close(alert: Alert) {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }
}
